var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAkcija(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-6,.cls-7{fill:none;stroke-miterlimit:10;stroke-width:1.5px;}.cls-1{stroke:#aa6276;}.cls-2{fill:#fa7268;}.cls-3{stroke:#fff;}.cls-4{fill:#6e5dd8;}.cls-5{fill:#159497;}.cls-6{stroke:#000;stroke-linecap:round;}.cls-7{stroke:#6e5dd8;}.cls-8{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420,256.2q-7.61-24.7-14.92-48L375.41,111.3q-7.92-25.5-14.33-46.45Q355.31,46,349.14,26.11A6.45,6.45,0,0,0,343,21.56H248.32a6.45,6.45,0,0,0-6.16,4.57q-5.82,19-11.65,37.73-6.52,21-14.62,47.44L186,208.16q-7.12,22.35-14.83,47.54t-14.63,47.74h75.3a7.9,7.9,0,0,0,7.66-6q4.64-18.21,9.56-37.73l1.08-4.32a5.53,5.53,0,0,1,5.36-4.17h77.72a5.52,5.52,0,0,1,5.37,4.2c.36,1.49.73,3,1.1,4.49l9.75,40.1a4.44,4.44,0,0,0,4.32,3.39h74.69a4.45,4.45,0,0,0,4.25-5.76Q426.62,277.78,420,256.2ZM298.41,92.35,321,184.7a5.06,5.06,0,0,1-4.92,6.27H272.86a5.07,5.07,0,0,1-4.91-6.31l23.34-92.33a3.67,3.67,0,0,1,3.56-2.77h0A3.68,3.68,0,0,1,298.41,92.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.54,123s.11-11.1,0-15.37.24-12.58,1.8-16,8.14-10.22,11.95-13.16,7.11-4.34,8.32-2.6a4.92,4.92,0,0,1,0,5.89A13.86,13.86,0,0,0,240,84.79s7.5-.7,10.62,1.9,3.81,4,4,9-1.73,9-3.11,10-4.86.7-4.86.7a41.66,41.66,0,0,1-.34,10C245.42,121.87,240,127,240,127Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.39,
    y: 85.53,
    width: 51.12,
    height: 3.81,
    transform: "translate(-10.89 136.96) rotate(-32.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.61,98.65s4.34-8.15,5.89-9.88,3.3-2.89,4.9-1.33-1.6,10.32-1.6,10.32a13.93,13.93,0,0,1,4.85,7.47,11.26,11.26,0,0,1-1,8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "253.6 72.26 255.63 75.48 258.6 71.25 253.6 72.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146,109.79a5.11,5.11,0,0,0-5.12-5.11,5.05,5.05,0,0,0-2.61.74,29,29,0,1,0,4.4,9.14A5.09,5.09,0,0,0,146,109.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 493.51,
    cy: 128.57,
    r: 28.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 465.39,
    cy: 121.45,
    r: 5.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.42,148.59a48,48,0,0,1,.7-7.22,42,42,0,0,1,3.82-10.9,5.22,5.22,0,1,1,5.29-8.4c.41-.57.82-1.14,1.26-1.71,5.76-7.62,11.7-15,11.7-25.07-6.06-2.45-15.3-2.81-21.83-.9-10.41,3.06-19.54,9-30.22,11.38-7.87,1.78-15.92,1.73-23.86,3.09s-16.49,2-23.58,6.15c-5.87,3.43-12.21,9.7-14.49,16.25a38.8,38.8,0,0,0-.91,21c2.82,12.66,15,23.54,28.16,24.54,10.48.8,21.61-3.18,30-9.49,7.59-5.71,13.53-13.72,22.08-17.87A18.19,18.19,0,0,1,102.42,148.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.52,211a7.52,7.52,0,0,1,6.22-8,89.16,89.16,0,0,0,45.78-23.16A92.21,92.21,0,0,0,242.28,127a182.73,182.73,0,0,0-25.09-4.83,103.14,103.14,0,0,1-3.12,12.9,35.67,35.67,0,0,1-11.49,16.25c-11.61,9.1-27.63,10-42.3,8.45s-29.3-5.21-44-3.77a64,64,0,0,0-57,54.09,93.16,93.16,0,0,0-.73,17.59,96.1,96.1,0,0,0,3.83,24.72s.68,24.09,6.52,35,28.62,15.72,45.9,14.35,23.8-3.44,23.8-3.44S166.41,248.92,163.52,211Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "147.14 271.3 147.14 250.17 192.9 250.17 192.9 309.08 147.14 309.08 147.14 271.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.65,267.66s2.22-1.68,8.1-3.08,15.39-1.68,15.39-1.68v8.4s10.5-.42,16.24,0,7.83,2.1,8.11,6-2.94,15.11-8.67,17.63-23.37-1-29.25-2.94A131.11,131.11,0,0,1,121,286.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.77,249.13c2.46,7.91,8.88,18.69,15.23,24,14,11.69,30.67,14.13,45,13.72l2.85-20.51a31.65,31.65,0,0,1-10-4.68,51.24,51.24,0,0,1-20.34-57.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M545,131.82a14.81,14.81,0,0,0-6.12-15,14.44,14.44,0,0,0,1.34-3.89,14.78,14.78,0,0,0-18.59-17,14.78,14.78,0,0,0-26.81-9.31A14.8,14.8,0,1,0,483,113.22a14.79,14.79,0,0,0,7,25.59h0c-.11.39-.22.78-.3,1.19a14.79,14.79,0,0,0,22.4,15.34,14.8,14.8,0,0,0,25.23-13.22A14.78,14.78,0,0,0,545,131.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 58.43,
    cy: 73.37,
    r: 5.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 345.36,
    cy: 279.36,
    r: 5.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.23,157.38C421.19,153.92,410,145,402,134.15S389.1,110.44,385.66,97.4c-1.32-5-3.86-9.65-6.41-14.16a6,6,0,0,0-10.64.23,7.91,7.91,0,0,0-12.66.85c-1.72-2.4-5.32-3-8-1.68l-.08,0a4.85,4.85,0,0,0,.81,8.87l4.2,1.4a11.5,11.5,0,0,1,7.84,10.91h0a11.49,11.49,0,0,1-7.54,10.79l-2.28.84a3.33,3.33,0,0,0-.31,6.14,10.38,10.38,0,0,0,2.91.8,53.06,53.06,0,0,0,12.39-.39s5.51,24.15,17.21,35.34,24.45,21.17,33.4,25,11.7,4.13,11.7,4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M434.23,157.38s3.64-8.44,17.07-9.81,19.53,9.81,19.53,9.81-1.28,11.53,8.36,15,23.41-5.5,23.41-5.5,14.11-4.14,27.19.68,18.87,13.77,20.63,21.35a26.93,26.93,0,0,1,0,13.08,25.74,25.74,0,0,1-9.26,12.74c-5.21,3.64-8.61,6.54-8.61,6.54s4.13,17.58,4.82,28.93-3.1,32-3.1,32-18.93,6.54-38.21,7.57-30.35-2.86-30.35-2.86-13.38-30.53-17.16-47.75,1.72-41.65,1.72-41.65a30.6,30.6,0,0,1-13.77-2.41c-7.23-3.1-8.27-8.61-8.27-8.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 350.43,
    cy: 103.62,
    r: 11.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.95,
    cy: 109.93,
    r: 1.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.5,
    cy: 118.29,
    r: 1.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.92,126.84a4.53,4.53,0,0,1-6.42,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M473.72,134.39a4.53,4.53,0,0,1-6.42,0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 436.7,
    y: 276.41,
    width: 73.59,
    height: 27.03,
    rx: 4.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M564.58,229.52a154.68,154.68,0,0,0-10-18.63c-6.3,6.2-12.65,12.35-19.25,18.23.6,1.44,1.33,3.08,2.2,4.94,4.09,8.73,13.85,25,13.85,25l-2.5,2.73c-2.49,2.72-19.07,16.35-23.84,15.67s-17.27-6.13-21.36-5.23a6.11,6.11,0,0,0-3.34,2,2.28,2.28,0,0,0,1.36,3.72L508,279s-15.47,1.13-16.37,5.45-1.37,12.95,2.65,17.49,6.89,4.54,13.72,4.09,23.38-3.91,40-15.49c13.15-9.19,24.67-23.64,28.88-29.22a4.6,4.6,0,0,0,.43-4.81C574.89,251.69,569.37,240.48,564.58,229.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M549.84,203.55a25.52,25.52,0,0,1-8.68,11.15c-5.21,3.64-8.61,6.54-8.61,6.54v0c.12.5,1.16,4.61,5,12.77.33.7.69,1.46,1.09,2.24a65.33,65.33,0,0,0,10.65-8c3.4-3.17,6.53-6.61,9.64-10.07C555.43,212,551.91,206.59,549.84,203.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 385.14,
    y: 21.27,
    width: 171.68,
    height: 52.1,
    rx: 26.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M423.24,73.37a20,20,0,0,0,20,20"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 225.07,
    y: 43.05,
    width: 14.69,
    height: 14.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 477.7,
    cy: 190.67,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 475.45,
    cy: 214.48,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 475.45,
    cy: 238.3,
    r: 4.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "150.35 37.96 155.35 29.3 145.35 29.3 150.35 37.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "566.15 150.35 561.15 159.01 571.15 159.01 566.15 150.35"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkcija);
export default __webpack_public_path__ + "static/media/Akcija.7bb571feffcf7fe26f316c833517c504.svg";
export { ForwardRef as ReactComponent };